import React from 'react';
import PropTypes from 'prop-types';
import classes from './checkDetail.module.scss';
import cn from 'classnames';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const FireboardTip = props => {
  const { selectedItem, currency = '$', suppressTipsOnFireBoard } = props || {};

  const getValue = field => {
    if (selectedItem && selectedItem[field] !== undefined) {
      return `${currency}${selectedItem[field].toFixed(2)}`;
    }
    return '';
  };

  return (
    <div className={cn(classes.subTotalSection, 'col-12 pb-0')}>
      <div className="col-12 px-0 h-100 d-flex align-items-end">
        <div className={cn('w-100', classes.totalSectionBorder)}>
          <div className="w-100 d-flex px-2 py-2 justify-content-between">
            <AmountDetail
              label={FLABEL().DETAILS_SUBTOTAL}
              value={getValue('subTotalAmount')}
              flexBasis={'50%'}
              align="text-left"
            />
            <AmountDetail
              label={FLABEL().DETAILS_ITEMS}
              value={getValue('itemAmount')}
              flexBasis={'50%'}
              align="justify-content-end"
            />
          </div>
          <div className="w-100 d-flex px-2 pb-2 justify-content-between">
            <AmountDetail
              label={FLABEL().DETAILS_DISCOUNTS}
              value={getValue('discountAmount')}
              flexBasis={'33%'}
              align="text-left"
            />
            <AmountDetail
              label={FLABEL().DETAILS_CHARGES}
              value={getValue('serviceChargeAmount')}
              flexBasis={'35%'}
              align="justify-content-end"
            />
            <AmountDetail
              label={FLABEL().DETAILS_TAX}
              value={getValue('taxAmount')}
              flexBasis={'31%'}
              align="justify-content-end"
            />
          </div>
          <div
            className={cn(
              'w-100 d-flex px-2 py-2 justify-content-between',
              classes.totalSection
            )}
          >
            {suppressTipsOnFireBoard ? null : (
              <AmountDetail
                label={FLABEL().DETAILS_TIP}
                value={getValue('tipAmount')}
                flexBasis={'33%'}
                align="text-left"
              />
            )}
            <AmountDetail
              label={FLABEL().DETAILS_PAID}
              value={getValue('paidAmount')}
              flexBasis={'33%'}
              align="text-center"
            />
            <AmountDetail
              label={FLABEL().DETAILS_DUE}
              value={getValue('unpaidAmount')}
              flexBasis={'33%'}
              align="justify-content-end"
              customClass={cn(classes.dueAmount)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FireboardTip;

const AmountDetail = ({ label, value, flexBasis, align, customClass }) => {
  return (
    <div
      className={cn(
        classes.tooltipItemContainer,
        `col-6 px-0 d-flex align-items-center ${align}`
      )}
      style={{ flexBasis: flexBasis }}
    >
      <span className={cn('pr-1', classes.amountLabel)}>{label}</span>
      <span className={cn(customClass)}>{value}</span>
    </div>
  );
};

AmountDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexBasis: PropTypes.string,
  align: PropTypes.string,
  customClass: PropTypes.string,
};
